export default "__VITE_ASSET__BP1oVmdu__"